// extracted by mini-css-extract-plugin
module.exports = {"occasions":"bundleOccasionsList_occasions__1xdPV","occasion":"bundleOccasionsList_occasion__1VUPC","suppressMargins":"bundleOccasionsList_suppressMargins__3r0f8"};